import store from '@/store'

export function getLevel(robotId) {
    if (!robotId) {
        robotId = store.state.robotId
    }
    let level = store.state.level
    if (robotId === 'exercises') {
        return 'h'
    } else if (robotId === 'mexercises') {
        return 'm'
    } else if (robotId === 'pexercises') {
        return 'p'
    } else if (level === 'h') {
        return 'h'
    } else if (level === 'm') {
        return 'm'
    } else if (level === 'p') {
        return 'p'
    }
    return 'h'
}

export function getRobotByLevel(level) {
    if(!level) {
        level = getLevel();
    }
    if(level === 'm') {
        return "mexercises"
    } else if(level === 'p') {
        return "pexercises"
    } else {
        return "exercises"
    }
}